import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    margin: '5px 5px'
  }
};

const enhance = compose();

const button = enhance(({ classes, onClickAction }) => {
  return (
    <Button
      variant="contained"
      color="secondary"
      onClick={onClickAction}
      className={classes.button}
    >
      画像アップロード
    </Button>
  );
});

export default withRouter(withStyles(styles)(button));
